<template>
  <hr
    aria-orientation="horizontal"
    class="s-divider"
    :class="{'vertical': vertical}"
    role="separator"
    :style="componentStyle">
</template>
<script>
/**
* Разделительная линия
 * @displayName Divider
*/
export default {
  name: 'sDivider',
  computed: {
    componentStyle() {
      return `--size: ${this.size}px;--color: ${this.color};`
    }
  },
  props: {
    /**
     * Цвет разделителя
     */
    color: {
      type: String,
      default: 'var(--divider-color)'
    },
    /**
     * Толщина/размер разделителя
     */
    size: {
      type: [String, Number],
      default: 1
    },
    /**
     * Вертикальный разделитель
     */
    vertical: {
      type: Boolean
    }
  }
}
</script>
<style lang="scss" scoped>
.s-divider {
  border-style: solid;
  border-color: var(--color);
  border-top-width: var(--size);
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
    &.vertical {
      height: auto;
      border-top-width: 0px;
      border-right-width: var(--size);
    }
}
</style>
